import React, { Fragment, useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { Row, Col, Form, Label, FormGroup, Button, Input } from "reactstrap";
import RequiredField, {
  FirstName,
  LastName,
  Submit,
  Cancel,
  BirthDate,
  Age,
  MobileNo,
  AadharNumber,
  Gender,
  Address,
  Department,
  Password,
  ConfirmPassword,
  Option1,
} from "../../../Constant";
import { Breadcrumbs, Image } from "../../../AbstractElements";
import { useNavigate, useLocation } from "react-router";
import {
  CreateDoctor,
  DoctorDepartmentList,
  UpdateDocor,
  UpdateDoctor,
} from "../../../apiController";
import { toast } from "react-toastify";
import { faL } from "@fortawesome/free-solid-svg-icons";

const DoctorForm = ({ setSteps }) => {
  const navigate = useNavigate();

  const location = useLocation();
  const [department, setDepartment] = useState([]);
  const [base64, setBase64] = useState("");

  const { rowData } = location.state || {};

  const [formdata, setFormdata] = useState({});
  const [url, setUrl] = useState("");

  const readUrl = (event) => {
    if (event.target.files.length === 0) return;
    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      setUrl(reader.result);
    };
  };

  const {
    control,
    register,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  if(rowData){
    setValue('department', rowData?.department_id)
  }

  const onSubmit = async (data) => {
    // console.log(data)
    setFormdata((prev) => ({ ...prev, ...data }));
    // setSteps((prev) => prev + 1);
    console.log(data);

    const formattedData = {
      image: data.image,
      first_name: data.firstName,
      surname: data.lastname,
      department_id: data.department,
      phone: data.phone,
      qualification: data.qualification,
      email: data.email,
      address: data.addr,
      age: data.age,
      dob: data.birthday,
      gender: data.gender ? data.gender : data.genderfe,
      aadhar_number: data.aadharnumber,
      password: data.password,
      confirm_password: data.confirmpassword,
      id: rowData ? rowData.id : "",
    };
    console.log(formattedData);
    try {
      if (rowData) {
        const response = await UpdateDoctor(formattedData);
        if (response.status === true) {
          toast.success("Updated Successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
        navigate(`${process.env.PUBLIC_URL}/doctor/:layout>}`);
      } else {
        const response = await CreateDoctor(formattedData);
        if (response.status === true) {
          toast.success("Created Successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
        } else if (response.status === false) {
          toast.error(response.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
        navigate(`${process.env.PUBLIC_URL}/doctor/:layout>}`);
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    reset();
  };
  // const onSubmit = (data) => {
  //   setFormdata((prev) => ({ ...prev, ...data }));
  //   setSteps((prev) => prev + 1);
  // };

  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    if (rowData?.dob) {
      reset({
        birthday: rowData.dob,
      });
    }
  }, [rowData, reset]);

  const [age, setAge] = useState("");

  // Watch for changes in the birthday field
  const dob =  watch("birthday");

  useEffect(() => {
    if (dob) {
      const dobDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - dobDate.getFullYear();
      const monthDiff = today.getMonth() - dobDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < dobDate.getDate())
      ) {
        age--;
      }
      setAge(age);
      setValue("age", age);
    }
  }, [dob, setValue]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64(reader.result);
        setValue("image", reader.result); // Set base64 string in form
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchDoctorDepartment = async () => {
    const response = await DoctorDepartmentList();
    if (response.status === true) {
      setDepartment(response.data);
    }
  };

  useEffect(() => {
    fetchDoctorDepartment();
  }, []);

  return (
    <Fragment>
      <Breadcrumbs
        parent="Doctor"
        mainTitle="Doctor Form"
        title="Doctor Form"
      />
      <div className="login-main">
        <Form
          onSubmit={handleSubmit(onSubmit)}
          className="theme-form login-form needs-validation"
        >
          <Row>
            <Col sm="12" xl="6" className="custom-padding-lg">
              {!rowData && (
                <FormGroup className="mb-3">
                  {!base64 && (
                    <>
                      <Label htmlFor="fname">{"Image"}</Label>
                      <input
                        className={`form-control ${
                          errors.image && "is-invalid"
                        }`}
                        id="image"
                        type="file"
                        name="firstname"
                        accept=".jpg, .jpeg, .png"
                        defaultValue={formdata.image || ""}
                        {...register("image", { required: false })}
                        onChange={handleFileChange}
                      />
                      <span className="text-danger">
                        {errors.image && "Image is required"}
                      </span>
                    </>
                  )}
                  {base64 && (
                    <div>
                      <img
                        src={base64}
                        alt="Selected"
                        style={{ maxWidth: "100px", maxHeight: "100px" }}
                      />
                    </div>
                  )}
                </FormGroup>
              )}
              <FormGroup className="mb-3">
                <Label htmlFor="fname">
                  {FirstName} <RequiredField />
                </Label>
                <input
                  className={`form-control ${errors.firstName && "is-invalid"}`}
                  id="fname"
                  type="text"
                  name="firstname"
                  defaultValue={rowData?.first_name || ""}
                  {...register("firstName", { required: true })}
                />
                <span className="text-danger">
                  {errors.firstName && "First name is required"}
                </span>
              </FormGroup>
              <FormGroup className="mb-3">
                <Label htmlFor="lname">
                  {LastName} <RequiredField />
                </Label>
                <input
                  className={`form-control ${errors.lastname && "is-invalid"}`}
                  id="lname"
                  type="text"
                  name="lastname"
                  defaultValue={rowData?.surname || ""}
                  {...register("lastname", { required: true })}
                />
                <span className="text-danger">
                  {errors.lastname && "Last name is required"}
                </span>
              </FormGroup>
              <FormGroup className="mb-3">
                <Label htmlFor="mobilenumber">
                  {MobileNo} <RequiredField />
                </Label>
                <input
                  className={`form-control ${errors.phone && "is-invalid"}`}
                  id="phone"
                  type="number"
                  name="phone"
                  maxLength={10}
                  defaultValue={rowData?.phone || ""}
                  {...register("phone", {
                    required: true,
                    minLength: {
                      value: 10,
                      message: "Phone number must be at least 10 digits",
                    },
                    maxLength: {
                      value: 10,
                      message: "Phone number must be exactly 10 digits",
                    },
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Phone number must contain only digits",
                    },
                  })}
                />
                <span className="text-danger">
                  {errors.phone && "MobileNo is required"}
                </span>
              </FormGroup>
              {/* <FormGroup className="mb-3">
                <Label htmlFor="Bdate">
                  {BirthDate} <RequiredField />
                </Label>
                <input
                  className={`form-control ${errors.birthday && "is-invalid"}`}
                  id="Bdate"
                  type="date"
                  name="birthday"
                  defaultValue={rowData?.dob || ""}
                  {...register("birthday", { required: true })}
                  max={today}
                />
                <span className="text-danger">
                  {errors.birthday && "Birth Date is required"}
                </span>
              </FormGroup>
              <FormGroup className="mb-3">
                <Label htmlFor="age">
                  {Age}
                  <RequiredField />
                </Label>
                <input
                  className={`form-control ${errors.age && "is-invalid"}`}
                  id="age"
                  type="number"
                  name="age"
                  max="100"
                  defaultValue={rowData?.age || ""}
                  {...register("age", {
                    required: true,
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Age must contain only digits",
                    },
                  })}
                /> */}
              <FormGroup className="mb-3">
                <Label htmlFor="Bdate">
                  {BirthDate} <RequiredField />
                </Label>
                <Controller
                  control={control}
                  name="birthday"
                  render={({ field }) => (
                    <input
                      {...field}
                      className={`form-control ${
                        errors.birthday && "is-invalid"
                      }`}
                      id="Bdate"
                      type="date"
                      max={new Date().toISOString().split("T")[0]} 
                    />
                  )}
                />
                <span className="text-danger">
                  {errors.birthday && "Birth Date is required"}
                </span>
              </FormGroup>
              <FormGroup className="mb-3">
                <Label htmlFor="age">
                  {Age} <RequiredField />
                </Label>
                <input
                  className={`form-control ${errors.age && "is-invalid"}`}
                  id="age"
                  type="number"
                  name="age"
                  value={rowData?.age? rowData.age: age}
                  disabled
                />
                <span className="text-danger">
                  {errors.age && "Age is required"}
                </span>
              </FormGroup>
              {/* <span className="text-danger">
                  {errors.age && "Age is required"}
                </span>
              </FormGroup> */}
              <FormGroup>
                <Label htmlFor="gender">
                  Gender <RequiredField />
                </Label>
                <div className="d-flex gap-3">
                  <div className="custom-control custom-radio">
                    <Controller
                      name="gender"
                      control={control}
                      rules={{ required: false }}
                      render={({ field }) => (
                        <>
                          <Input
                            className="custom-control-input"
                            id="male"
                            type="radio"
                            value={
                              rowData?.gender === "male" ? rowData?.gender : ""
                            }
                            checked={field.value === "male"}
                            onChange={() => field.onChange("male")}
                          />
                          <Label
                            className="custom-control-label"
                            htmlFor="male"
                          >
                            Male
                          </Label>
                        </>
                      )}
                    />
                  </div>
                  <div className="custom-control custom-radio">
                    <Controller
                      name="gender"
                      control={control}
                      rules={{ required: false }}
                      render={({ field }) => (
                        <>
                          <Input
                            className="custom-control-input"
                            id="female"
                            type="radio"
                            value={
                              rowData?.gender === "female"
                                ? rowData?.gender
                                : ""
                            }
                            checked={field.value === "female"}
                            onChange={() => field.onChange("female")}
                          />
                          <Label
                            className="custom-control-label"
                            htmlFor="female"
                          >
                            Female
                          </Label>
                        </>
                      )}
                    />
                  </div>
                </div>
              </FormGroup>
              {/* <FormGroup className="mb-3">
                <Label htmlFor="gender">
                  {Gender} <RequiredField />
                </Label>
                <div className="d-flex gap-3">
                  <div className="custom-control form-check custom-radio">
                    <Input
                      className="custom-control-input"
                      id="customControlValidation2"
                      type="radio"
                      name="radio-stacked"
                      defaultValue="male"
                      {...register("gender", { required: false })}
                      
                    />
                    <Label
                      className="custom-control-label"
                      htmlFor="customControlValidation2"
                    >
                      {"Male"}
                    </Label>
                  </div>
                  <div className="custom-control form-check custom-radio">
                    <Input
                      className="custom-control-input"
                      id="customControlValidation3"
                      type="radio"
                      name="radio-stacked"
                      defaultValue="female"
                      {...register("genderfe", { required: false })}
                      
                    />
                    <Label
                      className="custom-control-label"
                      htmlFor="customControlValidation3"
                    >
                      {"Female"}
                    </Label>
                    <div className="invalid-feedback">
                      {"More example invalid feedback text"}
                    </div>
                  </div>
                </div>
              </FormGroup> */}
              {/* <FormGroup className="mb-3">
              <Label htmlFor="regno">{"Register Number (Format: WT-P000X)"} <RequiredField/></Label>
              <input className={`form-control ${errors.regno && "is-invalid"}`} id="regno" type="text" name="regno" defaultValue={formdata.regno || ""} {...register("regno", { required: true })} />
              <span className="text-danger">{errors.regno && "Register Number is required"}</span>
            </FormGroup> */}
              <FormGroup className="mb-3">
                <Label htmlFor="exampleFormControlSelect9">
                  {Department} <RequiredField />
                </Label>
                <select
                  type="select"
                  name="department"
                  className="form-control digits"
                  id="department"
                  // value={rowData?.department_id}
                  {...register("department", { required: true })}
                >
                  <option value="">{"Select Doctor Department"}</option>
                  {department.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.title}
                    </option>
                  ))}
                  {/* <option>{'Oral Implantology'}</option>
                                        <option>{'General Dentistry'}</option>
                                        <option>{'Community Dentistry'}</option>
                                        <option>{'Oral Medicine Radiology'}</option> */}
                </select>
                <span className="text-danger">
                  {errors.department && "Department is required"}
                </span>
              </FormGroup>
            </Col>
            <Col sm="12" xl="6" className="custom-padding-lg mb-3">
              <FormGroup className="mb-3">
                <Label htmlFor="address">{Address}</Label>
                <input
                  type="textarea"
                  className={`form-control ${errors.addr && "is-invalid"}`}
                  rows="3"
                  id="addr"
                  name="addr"
                  defaultValue={rowData?.address || ""}
                  {...register("addr", { required: false })}
                />
              </FormGroup>
              <FormGroup className="mb-3">
                <Label htmlFor="email">{"Email Address"}</Label>
                <input
                  className={`form-control ${errors.email && "is-invalid"}`}
                  id="email"
                  type="email"
                  name="email"
                  defaultValue={rowData?.email || ""}
                  {...register("email", { required: false })}
                />
                {/* <span className="text-danger">{errors.email && "Email is required"}</span> */}
              </FormGroup>
              <FormGroup className="mb-3">
                <Label htmlFor="qualification">{"Qualification"}</Label>
                <input
                  className={`form-control ${
                    errors.profession && "is-invalid"
                  }`}
                  id="qualification"
                  type="text"
                  name="qualification"
                  defaultValue={rowData?.qualification || ""}
                  {...register("qualification", { required: false })}
                />
                <span className="text-danger">
                  {errors.qualification && "qualification is required"}
                </span>
              </FormGroup>
              <FormGroup className="mb-3">
                <Label htmlFor="aadharnumber">
                  {AadharNumber} <RequiredField />{" "}
                </Label>
                <input
                  className={`form-control ${
                    errors.aadharnumber && "is-invalid"
                  }`}
                  id="aadharnumber"
                  type="number"
                  name="aadharnumber"
                  maxLength="12"
                  defaultValue={rowData?.aadhar_number || ""}
                  {...register("aadharnumber", { required: true })}
                />
                {/* <span className="text-danger">{errors.contactnumber && "contactnumber is required"}</span> */}
              </FormGroup>
              {!rowData && (
                <>
                  <FormGroup className="mb-3">
                    <Label htmlFor="password">
                      {Password} <RequiredField />
                    </Label>
                    <input
                      className={`form-control ${
                        errors.password && "is-invalid"
                      }`}
                      id="password"
                      type="password"
                      name="password"
                      defaultValue={formdata.password || ""}
                      {...register("password", { required: false })}
                    />
                    <span className="text-danger">
                      {errors.password && "password Name is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="relation">
                      {ConfirmPassword} <RequiredField />
                    </Label>
                    <input
                      className={`form-control ${
                        errors.confirmpassword && "is-invalid"
                      }`}
                      id="relation"
                      type="password"
                      name="confirmpassword"
                      defaultValue={formdata.confirmpassword || ""}
                      {...register("confirmpassword", { required: false })}
                    />
                    {/* <span className="text-danger">{errors.firstName && "First name is required"}</span> */}
                  </FormGroup>
                </>
              )}
              <div className="text-end btn-mb mt-5">
                <Button
                  className="secondary me-2"
                  onClick={() =>
                    navigate(`${process.env.PUBLIC_URL}/doctor/:layout>}`)
                  }
                >
                  {Cancel}
                </Button>
                <Button className="primary" type="submit">
                  {Submit}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </Fragment>
  );
};

export default DoctorForm;
